import type { VirtualSiteBatchUpdateDto } from "src/app/features/VirtualSiteGroup/types/VirtualSiteBatchUpdateDto";
import type { VirtualSiteBatchUpdateEntity } from "src/app/features/VirtualSiteGroup/types/VirtualSiteBatchUpdateEntity";

export const VirtualSiteBatchUpdateEntityToBatchUpdateDto = ({
    ...rest
}: Readonly<VirtualSiteBatchUpdateEntity>): VirtualSiteBatchUpdateDto => {
    return { ...rest };
};
